<template>
    <div>
		<tab name="1"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="9" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="商品ID" :value="1"></el-option>
                            <el-option label="商品名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="7" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择状态" size="small">
                        <el-option label="所有状态" value=""></el-option>
                        <el-option label="待上架" :value="3"></el-option>
                        <el-option label="销售中" :value="1"></el-option>
                        <el-option label="已下架" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="7" :xl="4">
                    <el-select v-model="params.categoryId" placeholder="请选择类别" size="small">
                        <el-option label="所有类别" value=""></el-option>
                        <template v-for="(item,index) in category">
                            <el-option :key="index" :label="'仅看' + item.label" :value="item.value"></el-option>
                        </template>
                    </el-select>
                </el-col>
                <!-- <el-col :xs="24" :sm="12" :md="7" :xl="4">
                    <el-select v-model="params.goodsType" placeholder="请选择商品使用场景" size="small">
                        <el-option label="不限制商品使用场景" value=""></el-option>
                        <el-option label="C端自用" :value="1"></el-option>
                        <el-option label="直播送礼" :value="2"></el-option>
                    </el-select>
                </el-col>5.4.6 -->
				<el-col :xs="24" :sm="12" :md="7" :xl="4">
				    <el-select v-model="params.deliveryType" placeholder="请选择商品使用场景" size="small">
				        <el-option label="不限制发货方式" value=""></el-option>
				        <el-option label="仅看快递发货的" :value="1"></el-option>
				        <el-option label="仅看现场自取的" :value="2"></el-option>
						<el-option label="仅看快递发货+现场自取的" :value="3"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="7" :xl="4">
				    <el-select v-model="params.balanceType" placeholder="请选择结算方式" size="small">
				        <el-option label="不限制结算方式" value=""></el-option>
				        <el-option label="仅看自营 - 预付款的" :value="1"></el-option>
				        <el-option label="仅看代销 - 后付款的" :value="2"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="7" :xl="4">
				    <el-select v-model="params.sellScope" placeholder="请选择销售范围" size="small">
				        <el-option label="不限制销售范围" value=""></el-option>
				        <el-option label="全平台用户" :value="0"></el-option>
				        <el-option label="白名单用户" :value="1"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="7" :xl="4">
				    <el-select v-model="params.freightTemplateId" placeholder="请选择运费模板" size="small">
				        <el-option label="不限制运费模板" value=""></el-option>				        
				        <el-option v-for="(item, index) in freightList" :key="index" :label="'仅看'+item.name+'的运费模板'" :value="item.id"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
             </el-row>
        </div>

        <div class="page-btns-box">
            <el-button v-if="$utils.have('/shop_good/createOrUpdate')" type="primary" icon="el-icon-plus" size="small" @click="add">新增商品</el-button>
        </div>

        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="商品ID"></el-table-column>
                <el-table-column prop="name" label="商品名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link class="ellipsis title" @click="$refs.H5Preview.show('/pages/goods/detail/detail?id='+scope.row.id)">
                            {{scope.row.name}}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="priceFormat" label="价格"></el-table-column>
                <el-table-column prop="categoryId" label="类别">
                    <template slot-scope="scope">
                        {{(category.filter(v => v.value == scope.row.categoryId))[0].label}}
                    </template>
                </el-table-column>
				<el-table-column prop="balanceType " label="结算方式" min-width="90">
				    <template slot-scope="scope">
				        <span v-if="scope.row.balanceType==1" >自营-预付款</span>				        
				        <span v-else-if="scope.row.balanceType==2">代销-后付款</span>
				    </template>
				</el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status==-1" type="info" size="mini">已删除</el-tag>
                        <el-tag v-else-if="scope.row.status==0" type="warning" size="mini">已下架</el-tag>
                        <el-tag v-else-if="scope.row.status==1" type="success" size="mini">销售中</el-tag>
                        <el-tag v-else-if="scope.row.status==2" type="danger" size="mini">已售罄</el-tag>
                        <el-tag v-else-if="scope.row.status==3" type="info" size="mini">待上架</el-tag>
                    </template>
                </el-table-column>
				<el-table-column prop="deliveryType" label="发货方式" min-width="150">
					<template slot-scope="scope">
						 <span v-if="scope.row.deliveryType==1" >快递发货</span>
						 <span v-else-if="scope.row.deliveryType==2">现场自取</span>
						 <span v-else-if="scope.row.deliveryType==3">快递发货+现场自取</span>
					</template>
				</el-table-column>
				<el-table-column prop="freightTemplateView" label="运费模板" min-width="200"></el-table-column>
                <el-table-column prop="totalStock" label="总量"></el-table-column>
                <el-table-column prop="sellStock" label="销量"></el-table-column>
                <el-table-column prop="remainStock" label="剩余库存"></el-table-column>
                <el-table-column prop="sort" label="序号"></el-table-column>
                <el-table-column prop="collectNum" label="收藏数"></el-table-column>
				<el-table-column prop="haveWhiteList" label="销售范围" min-width="150">
					 <template slot-scope="scope">
						 <span v-if="scope.row.haveWhiteList==0" >全平台用户</span>
						 <span v-else-if="scope.row.haveWhiteList==1">白名单用户</span>
					 </template>					
				</el-table-column>
                <el-table-column fixed="right" label="操作" width="380">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="view(scope.row)"
                            >预览</el-button
                        >
                        <el-button
                            v-if="$utils.have('/shop_good/createOrUpdate')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="scope.row.status != 0 && scope.row.status != 3 && $utils.have('/shop_good/offShelves')"
                            type="text"
                            size="small"
                            icon="el-icon-sold-out"
                            @click="out(scope.row.id,0)"
                            >下架</el-button
                        >
                        <el-button
                            v-if="(scope.row.status == 0 || scope.row.status == 3) && $utils.have('/shop_good/offShelves')"
                            type="text"
                            size="small"
                            icon="el-icon-sell"
                            @click="out(scope.row.id,1)"
                            >上架</el-button
                        >
                        <el-button
                            v-if="$utils.have('/shop_good/updateSort')"
                            type="text"
                            size="small"
                            icon="el-icon-sort"
                            @click="$refs.goodsSort.show(scope.row)"
                            >排序</el-button
                        >
                        <el-button
                            v-if="$utils.have('/shop_good/goodsSellData')"
                            type="text"
                            size="small"
                            icon="el-icon-coin"
                            @click="$refs.goodsData.show(scope.row.id)"
                            >数据</el-button
                        >
						<el-button
						    v-if="(scope.row.haveWhiteList == 1 ) && $utils.have('/shopGoodsWhite/pageList')"
						    type="text"
						    size="small"
						    icon="el-icon-coin"
						    @click="whitelist(scope.row.id)"
						    >白名单</el-button
						>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <GoodsView ref="goodsView"></GoodsView>
        <GoodsData ref="goodsData"></GoodsData>
        <GoodsSort ref="goodsSort" @onUpdate="getDataList"></GoodsSort>
        <H5Preview ref="H5Preview"></H5Preview>
    </div>
</template>

<script>
import GoodsView from '@/components/CodeView';
import GoodsData from './components/goods-data';
import GoodsSort from './components/goods-sort';
import H5Preview from '@/components/H5Preview';
import Tab from './components/tab'
const defaultParams = {
    pageNo: 1,
    value: '',
    type:2,
    status:'',
    categoryId:'',
    //goodsType: '',
	deliveryType:'',
	balanceType:'',
	sellScope:'',
	freightTemplateId:''
}
export default {
    components:{GoodsView,GoodsData,GoodsSort,H5Preview,Tab},
    data (){
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                value: this.$route.query.value || '',
                type:parseInt(this.$route.query.type || 2),
                status:this.$route.query.status ? parseInt(this.$route.query.status) : '',
                categoryId:this.$route.query.categoryId ? parseInt(this.$route.query.categoryId) : '',
				freightTemplateId:this.$route.query.freightTemplateId ? parseInt(this.$route.query.freightTemplateId) : '',
            },
            listLoading: true,
            sswap:process.env.VUE_APP_SSWAP_URL,
			freightList:[]
        }
    },
    computed:{
        category(){
            return [
                {value:1,label:'唱片专辑'},
                {value:2,label:'服饰'},
                {value:3,label:'纪念品'},
                {value:5,label:'配饰'},
                // {value:6,label:'照片'},
                {value:7,label:'数藏'},
                {value:4,label:'其它'},
				{value:8,label:'积分商品'},
				{value:9,label:'实体纪念票'},
            ]
        },
    },
    mounted(){        
		this.getfreightList();
		this.getDataList();
    },
    methods:{
        //获取列表
        getDataList(){
            this.listLoading = true;
            this.$request({
                url: '/shop_good/list',
                method: 'POST',
                data: this.params
            }).then(res => {
                const { state, msg, result } = res.data;
                if( state == 1 && result ){
                    this.data = result;
                    this.dataList = result.result || [];
                }else{
                    this.$message.error(msg || '请求失败');
                }
            }).catch(() => {
                this.$message.error('请求错误');
            }).finally(() => {
                this.listLoading = false;
            });
        },
		//获取模板列表 
		getfreightList(){
		    this.listLoading = true;
		    this.$request({
		        url: '/freight/management/selectList',
		        method: 'POST',		       
		    }).then(res => {
		        const { state, msg, result } = res.data;
		        if( state == 1 && result ){		          
		            this.freightList = result || [];
		        }else{
		            this.$message.error(msg || '请求失败');
		        }
		    }).catch(() => {
		        this.$message.error('请求错误');
		    }).finally(() => {
		        this.listLoading = false;
		    });
		},
        //选择pageSize
        handleSizeChange( e ){
            this.params.pageNo = 1
            this.params.pageSize = e
            this.getDataList()
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize				
            }
            this.getDataList();
        },

        //预览
        view(item){
            this.$refs.goodsView.show({
                ...item,
                qrCodeUrl: this.sswap+'/pages/goods/detail/detail?id='+item.id
            })
        },
        //下架
        out(id,type){
            const _msg = type == 0 ? '确定要将此商品下架吗?' : '确定要将此商品上架吗?';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/shop_good/offShelves',
                    method: 'POST',
                    params: {id:id}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataList();
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            }).catch(() => {})
        },
        add(){
            this.$router.push('/goodsManage/goods/add');
        },
        edit(id){
            this.$router.push({
                path:`/goodsManage/goods/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
		whitelist(id){
			this.$router.push({
			    path:`/goodsManage/goods/whitelist/${id}`,
			    query: {
			        redirect: this.$utils.objArgs(
			            this.$router.currentRoute.path,
			            this.params
			        ),
			    },
			});
		}
    }
}
</script>